import * as React from "react"
import {isEmpty as _isEmpty, get as _get} from "lodash"
import ModelFactory from "../models/ModelFactory";
import ToggleButtonList from "./ToggleButtonList";
import IStaticDataValue from "../../../common/models/IStaticDataValue";
import IFrequency from "../../../common/models/IFrequency";
import TextInput from "../components/TextInput"

export interface QuantityDurationComponentProps {
    keyName?: string,
    widgetName?: string
    disabled?: boolean,
    unit: string,
    count: string,
    rootClass: string,
    onDurationChange?: (schedule: IFrequency) => any,
    placeholder?: string,
    isFrequency?: boolean,
    toggleValues: IStaticDataValue[],
    selectionData: {parentToggleKey: IStaticDataValue, values: IStaticDataValue[]}[],
    unitList: IStaticDataValue[]
}

const AdvancedDurationComponent = (props: QuantityDurationComponentProps) => {

    const handleSuggestionSelect = (values: string[]) => {
        const selectedSuggestion = values.slice(-1)[0];
        const count = props.count || "1"
        const duration = selectedSuggestion ? ModelFactory.createNewFrequency(selectedSuggestion, count) : null;
        props.onDurationChange(duration);
    }

    const handleCountChange = (event: any) => {
        const {value} = event.target
        const numericValue = value.replace(/[^0-9]/g, "")
        let unit = props.unit
        if (!_isEmpty(numericValue) && !props.unit) {
            const firstToggleValue = _get(props.toggleValues, "0.internalValue", "")
            if (["SOS", "STAT"].indexOf(firstToggleValue) < 0) {
                unit = props.toggleValues[0].internalValue
            } else {
                unit = props.toggleValues[1].internalValue
            }
         }
        let duration = ModelFactory.createNewFrequency(unit, numericValue)
        if (_isEmpty(numericValue) && props.unit) {
            duration = null
        }
        props.onDurationChange(duration);
    }

    const selectedSuggestedItem = props.unit ? [props.unit] : [];
    return (
        <div className={"advanced-duration-component"}>
            <div className={"duration-input-container"}>
                <TextInput value={props.count || ""} placeholder={"Enter"} onChange={handleCountChange} />
            </div>
            <div className={"duration-options-container"}>
                <ToggleButtonList
                    keyName={props.keyName}
                    widgetName={props.widgetName}
                    listItems={props.toggleValues}
                    selectedItems={selectedSuggestedItem}
                    onSelectionChange={handleSuggestionSelect}
                />
            </div>
        </div>
    )
}

export default AdvancedDurationComponent;